<template>
    <Transition>

        <div class="notification-wrapper" @click.self="notifNotVisible" v-if="isVisible">

            <div class="notification">
                <div class="notification-details-1" v-if="notificationType == '1'">

                    <img :src="notificationDetail.peerMeta.icons.length > 0 ? notificationDetail.peerMeta.icons[0] : ''"
                        alt="" class="notification-img" />
                    <div class="notification-url">
                        {{ notificationDetail.peerMeta.url }}

                    </div>
                    <div class="notification-name">
                        {{ notificationDetail.peerMeta.name }}

                    </div>

                    <div class="notification-name">
                        {{ $t('walletconnect.yourAddress') }} <br>{{ fixNumber(notificationDetail.address) }}

                    </div>

                    <div class="notification-ask">
                        {{ $t('walletconnect.wantsToConnect') }}
                    </div>
                </div>
                <div class="notification-details" v-else-if="params">
                    <div class="notification-detail" v-for="(param, index) in params" :key="index">
                        <div class="title">
                            {{ param.label }}
                        </div>
                        <div class="detail">
                            {{ param.value }}

                        </div>
                    </div>

                </div>
                <div class="notification-details" v-else>
                    {{ notificationDetail }}
                </div>

                <div class="buttons-wrapper">
                    <button class="accept-button" @click="accept">{{ $t('walletconnect.accept') }}</button>
                    <button class="reject-button" @click="reject">{{ $t('walletconnect.reject') }}</button>
                </div>

            </div>

        </div>
    </Transition>

</template>

<script>
import { fixTheAddress } from "@/filters/index";
import { signingMethods, convertHexToNumber, convertHexToUtf8 } from "@walletconnect/utils";

export default {
    data() {
        return {
            params: null
        }
    },

    props: {
        notificationDetail: {
            type: [Object, Array]
        },
        notificationType: {
            type: String
        },
        notificationId: {
            type: Number
        },
        isVisible: {
            type: Boolean
        }
    },

    methods: {
        accept() {
            this.$emit('accept', { type: this.notificationType, detail: this.notificationDetail, id: this.notificationId })
        },
        reject() {
            this.$emit('reject', { type: this.notificationType, detail: this.notificationDetail, id: this.notificationId })
        },
        notifNotVisible() {
            this.$emit('hideNotif', this.notificationId)
        },

        fixNumber(number) {
            return fixTheAddress(number)
        },

        renderEthereumRequests() {
            let payload = {}
            payload.method = this.notificationType
            payload.params = this.notificationDetail
            let params = [{ label: this.$t('walletconnect.method'), value: payload.method }];

            switch (payload.method) {
                case "eth_sendTransaction":
                case "eth_signTransaction":
                    params = [
                        ...params,
                        { label: this.$t('walletconnect.from'), value: payload.params[0].from },
                        { label: this.$t('walletconnect.to'), value: payload.params[0].to },
                        {
                            label: this.$t('walletconnect.gaslimit'),
                            value: payload.params[0].gas
                                ? this.convertHexToNumberPossible(payload.params[0].gas)
                                : payload.params[0].gasLimit
                                    ? this.convertHexToNumberPossible(payload.params[0].gasLimit)
                                    : "",
                        },
                        {
                            label: this.$t('walletconnect.gasprice'),
                            value: payload.params[0].gasPrice ? this.convertHexToNumberPossible(payload.params[0].gasPrice) : '',
                        },
                        {
                            label: this.$t('walletconnect.nonce'),
                            value: payload.params[0].nonce ? this.convertHexToNumberPossible(payload.params[0].nonce) : '',
                        },
                        {
                            label: this.$t('walletconnect.value'),
                            value:  payload.params[0].value ? this.convertHexToNumberPossible(payload.params[0].value) : "",
                        },
                        { label: this.$t('walletconnect.data'), value: payload.params[0].data ? payload.params[0].data : '' },
                    ];
                    break;

                case "eth_sign":
                    params = [
                        ...params,
                        { label: this.$t('walletconnect.address'), value: payload.params[0] },
                        { label: this.$t('walletconnect.message'), value: payload.params[1] },
                    ];
                    break;
                case "personal_sign":
                    params = [
                        ...params,
                        { label: this.$t('walletconnect.address'), value: payload.params[1] },
                        {
                            label: this.$t('walletconnect.message'),
                            value: this.convertHexToUtf8IfPossible(payload.params[0]),
                        },
                    ];
                    break;
                default:
                    params = [
                        ...params,
                        {
                            label: this.$t('walletconnect.params'),
                            value: JSON.stringify(payload.params, null, "\t"),
                        },
                    ];
                    break;
            }
            this.params = params;
        },

        convertHexToUtf8IfPossible(hex) {
            try {
                return convertHexToUtf8(hex);
            } catch (e) {
                return hex;
            }
        },

        convertHexToNumberPossible(hex){
            try {
                return convertHexToNumber(hex);
            } catch (e) {
                return hex;
            }
        }
   
    },

    mounted() {
        this.renderEthereumRequests()
    }
}
</script>

<style lang="scss" scoped>
.notification-wrapper {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 60;

    .notification {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100vw;
        background-color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 20px 20px 0 0;
        animation: jumpIn 1s ease;
        box-shadow: 0 0 80px rgba(0, 0, 0, 0.5);
        max-height: 95vh;
        overflow: auto;
        overflow-x: hidden;

        .notification-details-1 {
            display: flex;
            padding: 25px;
            align-items: center;
            flex-wrap: wrap;
            word-break: break-all;
            overflow-wrap: break-word;
            max-height: 90vh;
            overflow: auto;
            overflow-x: hidden;
            flex-direction: column;

            .notification-img {
                display: flex;
                width: 120px;
                height: 120px;
                border-radius: 8px;
            }

            .notification-name {
                margin: 15px;
                font-size: 18px;
                font-weight: bold;

            }
        }

        .notification-details {
            display: flex;
            padding: 25px;
            align-items: center;
            flex-wrap: wrap;
            word-break: break-all;
            overflow-wrap: break-word;
            max-height: 90vh;
            overflow: auto;
            overflow-x: hidden;

            .notification-img {
                display: flex;
                width: 120px;
                height: 120px;
                border-radius: 8px;
            }

            .notification-name {
                margin: 15px;
                font-size: 18px;
                font-weight: bold;

            }
        }

        .buttons-wrapper {
            display: flex;
            width: 100%;
            justify-content: center;
            margin: 10px;

            button {
                margin: 10px;
                padding: 10px 15px;
                border-radius: 8px;
                min-width: 100px;

            }

            button:active {
                transform: scale(0.95);
                opacity: 0.8;
            }

            .accept-button {
                background: #1296db;
                color: white;
            }
        }
    }
}

.notification-detail {
    display: flex;
    flex-direction: column;
    box-shadow: inset 0 0 10px 1px rgba(0, 0, 0, 0.1);
    width: calc(100% - 30px);
    border-radius: 8px;
    margin: 5px;
    padding: 5px 15px;
    flex-wrap: wrap;
    word-break: break-all;
    overflow-wrap: break-word;

    .title {
        font-size: 0.875rem;
        color: gray;
    }

    .detail {
        display: flex;
        flex-wrap: wrap;
        word-break: break-all;
        overflow-wrap: break-word;
    }
}

.v-enter-active,
.v-leave-active {
    transition: all 1s ease;
}

.v-enter-from,
.v-leave-to {
    transform: translateY(150%);
}

@keyframes jumpIn {
    0% {
        transform: translateY(150%);

    }

    100% {
        transform: translateY(0%);

    }
}
</style>